import { getStore as getSharedFavoritesStore } from 'owa-favorites';
import { action } from 'satcheljs/lib/legacy';
export var MARK_FOLDER_POPULATED_TIMEOUT = 30000;
export var markSearchFolderAsPopulated = action('markSearchFolderAsPopulated')(function markSearchFolderAsPopulated(favoriteNodeId) {
    var state = getSharedFavoritesStore();
    var personaNode = state.favoritesPersonaNodes.get(favoriteNodeId);
    // personaNode can be undefined if user removed favorite before the search folder has been populated
    if (personaNode) {
        personaNode.isSearchFolderPopulated = true;
    }
});
//# sourceMappingURL=markSearchFolderAsPopulated.js.map